import { useMutation } from '@tanstack/react-query'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from '../../../utils/showToast'
import { useDispatch } from 'react-redux'
import { auth_logout_action } from '../../../context/actions/auth_action'

export default function useLogoutMutation() {
  const dispatch = useDispatch()
  const logoutMutation = useMutation({
    mutationFn: async () => {
      await new Promise((resolve) => setTimeout(resolve, 500))
      dispatch(auth_logout_action())
      return true
    },
    onMutate: () => showLoadingToast('Đang đăng xuất, vui lòng chờ...'),
    onError: (error) => {
      showErrorToast({
        message: 'Đăng xuất thất bại',
        error: error.message || 'Không xác định',
      })
    },
    onSuccess: () => showSuccessToast('Đăng xuất thành công'),
  })
  return { logoutMutation }
}
